import React, { useContext } from 'react';
import { FilterContext } from "../../context/Filter"; // Make sure this path is correct

const Sparescard = (props) => {
    const { open } = useContext(FilterContext); // true if sidebar is open

    return (
        <div className={`shadow-[0_4px_5px_-1px_rgba(59,130,206,0.5)] bg-white   ml-8 m-1 mt-2 border  pt-2 rounded-xl text-gray-500 transition-all duration-300 
            ${open ? 'w-64' : 'w-80'}`} // dynamically change width
        >
            <div className='flex flex-col rounded-lg justify-center text-gray-400 justify-items-center'>
                <div className='flex justify-between gap-8 ml-5 mr-5 '>
                    {props.logo && (
                        <img src={props.logo} alt="logo" className="w-7 h-6 mb-1 text-left" />
                    )}
                    <div className='text-sm text-gray-500 font-semibold rounded-sm'>{props.heading}</div>
                    <div className='text-md justify-center text-gray-500 font-bold text-center rounded-sm'>{props.value}</div>
                </div>
                <div className='w-100'>
                    <hr className="border-t border-gray-300 my-2" />
                </div>
                <div className='flex gap-12 justify-between ml-5 mr-5 text-gray-400'>
                    {props.logo && (
                        <img src={props.logo} alt="logo" className="w-7 h-6 mb-1 text-left" />
                    )}
                    <div className='text-sm text-gray-500 font-semibold rounded-sm'>{props.heading2}</div>
                    <div className='text-md justify-center font-bold text-gray-500 text-center rounded-sm'>{props.value2}</div>
                </div>
            </div>
        </div >
    );
};

export default Sparescard;
